import ErrorPage from "pages/ErrorPage/ErrorPage";
import React from "react";
import { Outlet } from "react-router-dom";
import useAppContext from "state/AppContext";

export default function AuthenticatedUserFilter() {
  const appContext = useAppContext();
  const { account } = appContext;
  const { isAuthenticated } = account;
  // const location = useLocation();

  return isAuthenticated ? (
    <div className="my-0 py-0 min-h-screen">
      <Outlet />
    </div>
  ) : (
    // <Navigate to="/" state={{ from: location }} />
    <ErrorPage />
  );
}
